"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InputError = void 0;
var design_system_theme_1 = require("@unmind/design-system-theme");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var typography_1 = require("../../typography");
var ErrorTextSize = (_a = {},
    _a['small'] = design_system_theme_1.FontSizes.fontSize14,
    _a['medium'] = design_system_theme_1.FontSizes.fontSize16,
    _a);
var ErrorContainer = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  visibility: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: ", ";\n  border-radius: 16px;\n\n  ", "\n"], ["\n  visibility: ", ";\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  background-color: ", ";\n  border-radius: 16px;\n\n  ", "\n"])), function (_a) {
    var visible = _a.visible;
    return (visible ? 'visible' : 'hidden');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.background.error;
}, function (_a) {
    var variant = _a.variant, visible = _a.visible;
    return variant === 'detached' &&
        visible && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      margin-bottom: 12px;\n    "], ["\n      margin-bottom: 12px;\n    "])));
});
var DetachedContainer = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"], ["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n"])));
var ErrorText = (0, styled_components_1.default)(typography_1.BodyText).attrs(function (_a) {
    var $size = _a.$size, theme = _a.theme;
    return ({
        sizes: [ErrorTextSize[$size]],
        color: theme.colors.text.error,
    });
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 16px;\n"], ["\n  padding: 16px;\n"])));
/**
 * An error state rendered when an individual form input errors.
 *
 * Comes in 2 variants; `attached` and `detached`.
 * If using the `attached` variant you should render your input as a child of `InputError`.
 * The `detached` variant does not handle `children` and should be rendered above the relevant input.
 */
var InputError = function (_a) {
    var _b = _a.errorText, errorText = _b === void 0 ? '' : _b, errorMessageId = _a.errorMessageId, children = _a.children, _c = _a.size, size = _c === void 0 ? 'small' : _c, _d = _a.variant, variant = _d === void 0 ? 'attached' : _d;
    var errorIsVisible = Boolean(errorText.length);
    var Error = errorIsVisible ? (react_1.default.createElement(ErrorText, { id: errorMessageId, "$size": size, "aria-live": "polite" }, errorText)) : null;
    return variant === 'attached' ? (react_1.default.createElement(ErrorContainer, { variant: variant, visible: errorIsVisible },
        Error,
        children)) : (react_1.default.createElement(DetachedContainer, null,
        react_1.default.createElement(ErrorContainer, { variant: variant, visible: errorIsVisible }, Error)));
};
exports.InputError = InputError;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
